export enum AccountType {
  Card = 1,
  YooMoney = 3,
  Contact = 5,
  QIWI,
  SBP,
  VirtualCard = 9,
}
